export enum ThemeType {
  dark = 'dark',
  default = 'default'
}
